import React, { useMemo } from "react";
import { Video } from "lucide-react";
import AcademyModal from "./AcademyModal";
import { useAcademy } from "./AcademyContext";

// Riconosce YouTube/Vimeo e li incorpora come player embed; qualunque altro
// URL (es. un file .mp4 caricato altrove) viene mostrato con il tag <video>
// nativo. Il link è l'unico dato che il super_admin deve aggiornare dal
// pannello admin per cambiare il contenuto — nessun redeploy necessario.
function toEmbedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{6,})/);
  if (yt) return { kind: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return { kind: "iframe", src: `https://player.vimeo.com/video/${vimeo[1]}` };
  return { kind: "video", src: url };
}

export default function VideoModal() {
  const { content, videoOpen, closeVideo } = useAcademy();
  const video = content?.video;
  const embed = useMemo(() => toEmbedUrl(video?.url), [video?.url]);
  return (
    <AcademyModal open={videoOpen} onClose={closeVideo} icon={<Video className="h-5 w-5" />} title={video?.title || content?.title || "Videoguida"} subtitle="Videoguida" maxWidthCls="max-w-2xl">
      {!embed ? (
        <p className="text-sm text-slate-500">Videoguida non ancora disponibile per questa pagina.</p>
      ) : (
        <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
          {embed.kind === "iframe"
            ? <iframe className="h-full w-full" src={embed.src} title={video?.title || "Videoguida"} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
            : <video className="h-full w-full" src={embed.src} controls playsInline />}
        </div>
      )}
    </AcademyModal>
  );
}
